import React from 'react';
import agent from '../../../agent';
import { connect } from 'react-redux';
import { ADD_COMMENT } from '../../../constants/actionTypes';
import InfoModal from '../../../components/Utils/InfoModal';
import { createComment, createReplyComment } from '../../../actions/comments';
import MentionTextarea from '../../Utils/MentionTeaxtarea';
import { getLabel } from '../../../language'
import defaultAvatar from '../../../images/avatar.svg';

const mapStateToProps = state => {
    return {
        currentUser: state.common.currentUser,
        user: state.user,
        isOpen: false,
        anonymousMode: state.user.anonymousMode
    }
};

const mapDispatchToProps = dispatch => ({
    onSubmit: dispatch(createComment),
    onReplyComment: dispatch(createReplyComment),
});

class ReplyInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            replyMyPostsAndComments: this.props.post && this.props.replyMyPostsAndComments || 3,
        };

        this.onSubmitComment = this.onSubmitComment.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.onReplyComment = this.onReplyComment.bind(this);
    }

    onSubmitComment(ev) {
        ev.preventDefault();
        this.props.onSubmit(this.props.post.id, this.state.text, parseInt(ev.target.value), parseInt(ev.target.value));
        this.props.addCommentClick();
        this.setState({
            text: '',
            replyMyPostsAndComments: parseInt(ev.target.value),
        })
        this.props.onCancel(false);
    }

    onReplyComment(ev) {
        ev.preventDefault();
        this.props.onReplyComment(this.props.post.id, this.props.commentId, this.state.text, parseInt(ev.target.value), parseInt(ev.target.value));
        this.setState({
            text: '',
            replyMyPostsAndComments: parseInt(ev.target.value),
        })
        this.props.onCancel(false);
    }

    changeInput(ev) {
        this.setState({ text: ev.target.value });
    }

    openModal = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    render() {
        const { currentUser, user, onCancel } = this.props;
        return (
            <div className="row">
                {/*<InfoModal isOpen={this.state.isOpen} onClose={this.openModal} title={getLabel(62)} description={getLabel(58)} video={'https://www.youtube.com/embed/ji2f5WdYATA'} />*/}
                <div style={{width:'70%', position:'relative', top: 8, marginLeft: "auto"}}>
                    <MentionTextarea className="form-control with-border"
                                     changeBody={this.changeInput}
                                     rows={2}
                                     value={this.state.text}
                                     disabled={this.props.isAvailableForReply === false}
                                     placeholder={getLabel(59)} />
                </div>
                {/*<div className="col-md-1 col-1">*/}
                {/*  <a className="btn btn-default btn-sm small margintop" title="help" onClick={this.openModal} >*/}
                {/*    <i className="fa fa-question-circle pol" />*/}
                {/*  </a>*/}
                {/*</div>*/}
                <div className="m-l-5">
                  <span className="commentset text-right">
                      {this.state.replyMyPostsAndComments === 1 && <><button className={`btn btn-private${this.props.anonymousMode ? "-dark" : ""} r replylink reply_private ${parseInt(this.state.replyMyPostsAndComments) === 1 && ''}`} value={1} title={getLabel(217)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}></button></>}
                      {this.state.replyMyPostsAndComments === 2 && <><button className={`btn  btn-group${this.props.anonymousMode ? "-dark" : ""}  replylink reply_group ${parseInt(this.state.replyMyPostsAndComments) === 2 && ''}`} value={2} title={getLabel(218)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}></button></>}
                      {this.state.replyMyPostsAndComments === 3 && <><button className={`btn btn-public${this.props.anonymousMode ? "-dark" : ""}  replylink reply_public ${parseInt(this.state.replyMyPostsAndComments) === 3 && ''}`} value={3} title={getLabel(219)} onClick={this.props.replyComment ? this.onReplyComment : this.onSubmitComment}></button></>}
                      <span className="comment-option">  <button onClick={()=>onCancel(false)}>Cancel</button></span>
                  </span>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReplyInput);
